import { _removeMark } from 'common/Prose/Commands/marks'
import { preserveSelection } from 'common/Prose/utils'
import { activeMarksOfType } from 'common/Prose/utils/marks'
import { schema } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'

export const setHighlightColor = (color: string, view: EditorView) => {
  const { selection } = view.state
  const { empty } = selection
  let { ranges } = selection
  const tr = view.state.tr

  if (selection instanceof NodeSelection && 'highlightColor' in selection.node.attrs) {
    tr.setNodeMarkup(selection.from, undefined, { ...selection.node.attrs, highlightColor: color })
  } else if (empty) {
    // Upsert stored mark
    tr.removeStoredMark(schema.marks.highlighted)
    tr.addStoredMark(schema.marks.highlighted.create({ color }))

    const colorMarks = activeMarksOfType(schema.marks.colored, view.state)
    if (colorMarks.some((mark) => mark?.attrs['color']?.startsWith('linear-gradient'))) {
      tr.removeStoredMark(schema.marks.colored)
    }
  } else {
    ranges.forEach((range) => {
      const { $from, $to } = range,
        from = $from.pos,
        to = $to.pos

      view.state.doc.nodesBetween(from, to, (node, pos) => {
        const colorMark = schema.marks.colored.isInSet(node.marks)
        const codeMark = schema.marks.code.isInSet(node.marks)
        const endPos = Math.min(to, pos + node.nodeSize)

        if (node.isText && colorMark?.attrs['color']?.startsWith('linear-gradient')) {
          tr.removeMark(pos, endPos, schema.marks.colored)
        }

        if (node.isText && !codeMark) {
          tr.addMark(Math.max(pos, from), endPos, schema.marks.highlighted.create({ color }))
        }
      })

      preserveSelection(tr, view.state)
    })
  }

  view.dispatch(tr.scrollIntoView())
  view.focus()
}

export const removeHighlightColor = (view: EditorView) => {
  const { selection, tr } = view.state
  if (selection instanceof NodeSelection && 'highlightColor' in selection.node.attrs) {
    tr.setNodeMarkup(selection.from, undefined, { ...selection.node.attrs, highlightColor: null })
  } else {
    _removeMark(schema.marks.highlighted)(tr)
  }

  preserveSelection(tr, view.state)
  tr.scrollIntoView()

  view.dispatch(tr)
  view.focus()
}
